/* DSL Microsoft Clarity opt-in — fires only after consent.analytics === true */
(function(){
  var CFG = window.DSL_CONFIG || {};
  if (!CFG.clarityProjectId) return;
  function load(){
    if (window.clarity) return;
    (function(c,l,a,r,i){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};var t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;var y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", CFG.clarityProjectId);
  }
  function check(){
    var c = window.DSL_CONSENT && window.DSL_CONSENT.get();
    if (c && c.analytics) load();
  }
  document.addEventListener("dsl:consent:change", check);
  setTimeout(check, 1000);
})();